"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawDataMapperToJSON = exports.RawDataMapperFromJSONTyped = exports.RawDataMapperFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function RawDataMapperFromJSON(json) {
    return RawDataMapperFromJSONTyped(json, false);
}
exports.RawDataMapperFromJSON = RawDataMapperFromJSON;
function RawDataMapperFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'source': (0, _1.DataSourceFromJSON)(json['source']),
        'eventTypeId': !(0, runtime_1.exists)(json, 'eventTypeId') ? undefined : json['eventTypeId'],
        'mappings': json['mappings'],
        'gameId': !(0, runtime_1.exists)(json, 'gameId') ? undefined : json['gameId'],
        'jsonValidator': !(0, runtime_1.exists)(json, 'jsonValidator') ? undefined : json['jsonValidator'],
        'exampleData': !(0, runtime_1.exists)(json, 'exampleData') ? undefined : json['exampleData'],
        'incrementCounterField': !(0, runtime_1.exists)(json, 'incrementCounterField') ? undefined : json['incrementCounterField'],
        'isActive': !(0, runtime_1.exists)(json, 'isActive') ? undefined : json['isActive'],
    };
}
exports.RawDataMapperFromJSONTyped = RawDataMapperFromJSONTyped;
function RawDataMapperToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'name': value.name,
        'source': (0, _1.DataSourceToJSON)(value.source),
        'eventTypeId': value.eventTypeId,
        'mappings': value.mappings,
        'gameId': value.gameId,
        'jsonValidator': value.jsonValidator,
        'exampleData': value.exampleData,
        'incrementCounterField': value.incrementCounterField,
        'isActive': value.isActive,
    };
}
exports.RawDataMapperToJSON = RawDataMapperToJSON;
